module.exports = __webpack_public_path__ + "img/24-03.03c68912.png";